import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from './supabase';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    const redirectTo = `${window.location.origin}/reset-password`;
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });

    if (error) {
      setMessage(error.message);
    } else {
      setSent(true);
      setMessage('If an account exists for this email, a reset link has been sent. Check your inbox (and spam folder).');
    }
    setLoading(false);
  };

  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '3rem',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{
            fontSize: '1.75rem',
            fontWeight: '800',
            color: '#1f2937',
            margin: '0 0 0.5rem 0'
          }}>
            Reset your password
          </h1>
          <p style={{ color: '#6b7280', fontSize: '1rem', margin: 0 }}>
            Enter your email and we'll send you a link to reset it.
          </p>
        </div>

        {!sent && (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem',
                fontSize: '0.875rem'
              }}>
                Email Address
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '2px solid #e5e7eb',
                  borderRadius: '8px',
                  fontSize: '16px',
                  background: 'white',
                  color: '#374151',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px 28px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                cursor: loading ? 'not-allowed' : 'pointer',
                boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
          </form>
        )}

        {message && (
          <div style={{
            padding: '1rem',
            borderRadius: '8px',
            marginTop: sent ? 0 : '1.5rem',
            fontSize: '0.875rem',
            textAlign: 'center',
            background: sent ? '#f0fdf4' : '#fef2f2',
            color: sent ? '#15803d' : '#dc2626',
            border: sent ? '1px solid #22c55e' : '1px solid #ef4444'
          }}>
            {message}
          </div>
        )}

        <div style={{
          textAlign: 'center',
          paddingTop: '1.5rem',
          marginTop: '1.5rem',
          borderTop: '1px solid #e5e7eb'
        }}>
          <Link to="/" style={{
            color: '#667eea',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '0.875rem'
          }}>
            ← Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
